import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { getPercentages, updatePercentagesPagination } from '../../../store/actions/percentage/percentage_action';
import { makeStyles, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import TablePagination from '../../ui_components/table_pagination';
import { REACT_ROUTES } from '../../../constants/react_routes';
import history from '../../../services/history';
import ActionsComponent from '../../ui_components/actions_component';

const useStyles = makeStyles((theme) => ({
	paper: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto'
    },
    table: {
        minWidth: 500
    }
}));

const PercentagesTable = ({ percentages: { collection, totalCount, page, rowsPerPage, filters } }) => {
    const { paper, table, tableRow } = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!collection.length) {
            dispatch(getPercentages({ page, rowsPerPage, filters }));
        }
    }, []);

    const handleClick = (uuid) => {
        history.push(`${REACT_ROUTES.PERCENTAGE}/${uuid}`);
    }

    const handleDeleteArticle = (uuid) => {
        dispatch(deleteArticle(uuid))
            .then(() => dispatch(getPercentages({ page, rowsPerPage, filters })));
    }

    return (
        <Paper className={paper}>
            <Table aria-label="table" className={table}>
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Usluga</TableCell>
                        <TableCell align="center">Radnik</TableCell>
                        <TableCell align="center">Procenat (%)</TableCell>
                        <TableCell align="right">Akcije</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {collection.map(({ uuid, worker, article, percentage, deletable }, index) =>
                        <TableRow hover key={index} className={tableRow}>
                            <TableCell align="center">{ article.name }</TableCell>
                            <TableCell align="center">{ worker.displayName }</TableCell>
                            <TableCell align="center">{ percentage }</TableCell>
                            <TableCell align="right">
                                <ActionsComponent
                                    handleEdit={() => handleClick(uuid)}
                                    handleDelete={() => handleDeleteArticle(uuid)}
                                    deletable={deletable}
                                    label="uslugu"
                                />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                <TablePagination
                    page={page}
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    filters={filters}
                    updatePagination={updatePercentagesPagination}
                 />
            </Table>
        </Paper>
    )
}

PercentagesTable.propTypes = {
    percentages: PropTypes.object
}

const mapStateToProps = (state) => ({
    percentages: state.percentages
});

export default connect(mapStateToProps)(PercentagesTable);
